// extracted by mini-css-extract-plugin
export default {"container":"EVwYSPXjTsWIbh7_mocz","title":"RITmMZ18_gXWGwGxosRw","value":"Mf4zcV4JHHz9C3SumVGr"};